import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addCarrier: {
    description: 'button call to action text to add a carrier account',
    defaultMessage: 'Add Carrier',
    id: 'diDVFT',
  },
});
